export default __webpack_public_path__ + "static/media/Spring family wreath.3cb29f60.jpg";